export default __webpack_public_path__ + "static/hereLabLogo-c92ac690b6cd204a79396009f1f8bcf1.svg";